// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__("./node_modules/ts-loader/index.js!./src/sketcher.worker.ts");
